// extracted by mini-css-extract-plugin
export default {"dialogHeaderContainer":"SignedCommitDialog-module__dialogHeaderContainer--xEFRY","signatureLinkContent":"SignedCommitDialog-module__signatureLinkContent--ORyrR"};